import { Button } from "@dm-4dev/ui";
import { trackError } from "@mod/core/config/initialize-analytics";
import { useLocale } from "@mod/core/locale";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

export const ErrorPage = () => {
  const i18n = useLocale();
  const error = useRouteError() as any;

  const refreshPage = () => {
    // relaoad page
    window.location.reload();
  };

  useEffect(() => {
    trackError(error?.message ?? "Unknown error", true);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h3 className="text-4xl font-bold mb-4">Oops!</h3>
      <p className="text-lg text-gray-600">{i18n.genericErrorMessage}</p>
      <Button onClick={refreshPage}>Recargar</Button>
    </div>
  );
};
